module.exports = __webpack_public_path__ + "img/btimg.3f5bcbce.png";